// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"85":"0348993de411f504e49c","225":"9bcfab53798ac1579051","466":"0ae329630cd590b92e94"}[chunkId] + ".js";
};